import React, { useState } from 'react';
import { FaFacebookF, FaLinkedinIn, FaWhatsapp, FaArrowUp, FaArrowDown } from 'react-icons/fa'; 
import './SocialBtns.css'; 

const SocialBtns = () => {
  const [scrollUpNext, setScrollUpNext] = useState(true);

  const getPrimaryScrollContainer = () => {
    const isScrollable = (el) => {
      if (!el) return false;
      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const canScrollY = el.scrollHeight > el.clientHeight;
      return canScrollY && (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay');
    };

    const docScrollEl = document.scrollingElement || document.documentElement;
    if (isScrollable(docScrollEl)) return docScrollEl;

    const candidates = [
      document.querySelector('#root'),
      document.querySelector('main'),
      document.querySelector('.App'),
      document.body
    ];
    for (const el of candidates) {
      if (isScrollable(el)) return el;
    }

    // Fallback to documentElement
    return docScrollEl;
  };

  const animateScrollTo = (container, targetTop, durationMs = 600) => {
    const startTop = container.scrollTop;
    const distance = targetTop - startTop;
    if (distance === 0 || durationMs <= 0) {
      container.scrollTop = targetTop;
      return;
    }

    const easeInOutCubic = (t) =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    let startTime;

    const step = (timestamp) => {
      if (startTime === undefined) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(1, elapsed / durationMs);
      const eased = easeInOutCubic(progress);
      container.scrollTop = startTop + distance * eased;
      if (elapsed < durationMs) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  };

  const handleScrollToggle = () => {
    const container = getPrimaryScrollContainer();
    if (scrollUpNext) {
      animateScrollTo(container, 0);
    } else {
      const bottom = container.scrollHeight;
      animateScrollTo(container, bottom);
    }
    setScrollUpNext(!scrollUpNext);
  };

  return (
    <div className="social-btns">
      <button
        type="button"
        className='scroll-toggle-btn'
        onClick={handleScrollToggle}
        aria-label={scrollUpNext ? 'Scroll to top' : 'Scroll to bottom'}
        title={scrollUpNext ? 'Scroll to top' : 'Scroll to bottom'}
      >
        {scrollUpNext ? <FaArrowUp /> : <FaArrowDown />}
      </button>
      
    </div>
  );
};

export default SocialBtns;